module.exports = __webpack_public_path__ + "assets/5cf8af1ae2d6ab01172e74b7d1f834ca.png";